import Action from "./class.Action";

/**
 * Abandons the flow and creates a new traverse list
 * to a pointer with the the provided reference hash.
 */
export default class GoTo extends Action {
	constructor(options) {
		super(options);
		this.initialize();
	}

	async initialize() {
		// Get the document object with the matching reference.
		const found = _.findWhere(this.runnerController.root.body, {
			ref: this.model.goto_ref,
		});

		if (found) {
			// Create a new traverse list from this reference point.
			const index = this.runnerController.root.body.indexOf(found);
			const traverseList = this.runnerController
				.createFlowTraverseList(
					[],
					this.runnerController.root,
					AoPS.Transporter.CompositeObjectTypes._root.flow
				)
				.slice(index);

			this.onBypass();

			/**
			 * Traverse the new list.
			 * We pass the symbol of this action as the new context.
			 * This way, we know that any subsequent actions are logical
			 * descendants of this GoTo.
			 */
			this.runnerController.traverseFlowTraverseListTop({
				traverseList,
				onAdvance: _.bind(this.mainController.onComplete, this.mainController),
				onBypass: () => {},
				context: this.symbol,
				$anchor: this.$anchor,
			});
		} else {
			// The GoTo reference was bad.
			const bubbleView = this.layoutView.placeBubble(
				this.$anchor,
				this.method,
				"center"
			);
			bubbleView.setContent("<em>DEBUG: Bad GoTo.</em>");

			// Animate the bubble fading in.
			await this.animationController.FadeIn.start({
				extraBubbleView: bubbleView,
			}).scroll();

			// Advance the script.
			this.onAdvance(bubbleView.$el);
		}
	}
}
